import { MultipleChoiceExamIllustration } from '../../../../../assets/illustrations';
import { MultipleChoiceExamDetail } from '../../../../../store/exam/types';
import { setExamRulesModal } from '../../../../../store/exam/slice';
import { ArrowRightIcon } from '../../../../../assets/icons/common';
import MotionWrapper from '../../../../../containers/MotionWrapper';
import { useDispatch } from '../../../../../store/store';
import Spinner from '../../../../../components/Spinner';
import DropDown from '../../../../../components/DropDown';
import Button from '../../../../../components/Button';
import { ExamLanguage, hasLanguageChoice } from '../../../constants';
import styles from './style.module.scss';

interface Props {
    loading: boolean;
    action?: string;
    language: string;
    languages: ExamLanguage[];
    onStart: () => void;
    isCameraActive: boolean;
    onSelectLanguage: (language: string) => void;
    detail: MultipleChoiceExamDetail | null;
};

/** Entrance screen: what the exam involves and the button that starts it. */
function PreExam(props: Props) {
    const dispatch = useDispatch();

    const {
        detail,
        action,
        loading,
        onStart,
        language,
        languages,
        isCameraActive,
        onSelectLanguage,
    } = props;

    return (
        <MotionWrapper className={styles.wrapper}>
            <MultipleChoiceExamIllustration />
            {!detail ? <Spinner /> : (
                <>
                    <span className={styles.title}>Press the start button when you're ready</span>
                    <span className={styles.description}>It takes <b>{detail.time} minutes</b> to complete the exam</span>
                    {hasLanguageChoice(languages) && <DropDown
                        idKey='id'
                        titleKey='title'
                        label='Exam language'
                        dropDownList={languages}
                        containerClassName={styles.language}
                        selectedItem={languages.find(i => i.id === language)}
                        setItem={(item: ExamLanguage) => onSelectLanguage(item.id)}
                    />}
                    {!isCameraActive && <span className={styles.cameraAccess}>Please enable your camera access</span>}
                </>
            )}
            <Button
                type='Primary'
                onClick={onStart}
                loading={loading}
                className={styles.CTA}
                disabled={!detail || !isCameraActive}
                text={action === 'resume' ? 'Resume the exam' : 'Start the exam'}
            />
            <div className={styles.extra}>
                <span className={styles.extra_text}>Please review exam rules before starting the exam</span>
                <div
                    className={styles.extra_btn}
                    onClick={() => dispatch(setExamRulesModal(true))}
                >
                    <span>Exams rules</span>
                    <ArrowRightIcon />
                </div>
            </div>
        </MotionWrapper>
    )
};

export default PreExam;
